import * as React from 'react';

import { formatCurrency } from '../../utils';
import {
	Root,
	Integer,
	Fraction,
	Symbol,
	PrefixRoot,
} from './styled';


type CurrencyFormatterProps = {
	children: number;
	code?: string;
	locale?: string;
	separator?: string;
	fontSize?: number;
	fontWeight?: number | string;
	color?: string;
	prefix?: string | React.ReactElement<any>;
	needFraction?: boolean;
}

const CurrencyFormatterBase: React.SFC<CurrencyFormatterProps> = props => {
	const {
		children,
		code,
		locale,
		separator,
		fontSize,
		fontWeight,
		color,
		prefix,
		needFraction
	} = props;
	const patternSeparator = /[\,\.]/g;
	const patternSpace = String.fromCharCode(160);
	let parts;
	let integer;
	let integerWithSymbol;
	let fractionWithSymbol;
	let fraction;
	let symbol;

	if (typeof children === 'number') {
		parts = formatCurrency(children, code, locale).split(patternSeparator);
		integer = parts[0];

		if (parts[1]) {
			fractionWithSymbol = parts[1].split(patternSpace);
			fraction = fractionWithSymbol[0];
			symbol = fractionWithSymbol[1];
		} else {
			integerWithSymbol = integer.split(patternSpace);
			integer = integerWithSymbol[0];
			symbol = integerWithSymbol[1];
		}
	}

	return (
		<Root fontSize={fontSize} color={color}>
			{prefix || null}
			{prefix && `${patternSpace}`}
			<Integer fontWeight={fontWeight}>{integer}</Integer>
			{needFraction && !integerWithSymbol && separator}
			{needFraction && 
				<Fraction fontSize={fontSize}>
					{fraction}
				</Fraction>
			}
			{patternSpace}
			<Symbol fontWeight={fontWeight}>{symbol}</Symbol>
		</Root>
	);
};

CurrencyFormatterBase.defaultProps = {
	code: 'RUR',
	locale: 'ru',
	separator: ',',
	needFraction: true,
	fontWeight: 400,
};


const CurrencyFormatterPrefix: React.SFC<{isExpense: boolean}> = ({ isExpense }) => {
	return (
		<PrefixRoot isExpense={isExpense}>{isExpense ? '—' : '+'}</PrefixRoot>
	);
}

const CurrencyFormatter = {
	Base: CurrencyFormatterBase,
	Prefix: CurrencyFormatterPrefix,
}


export default CurrencyFormatter;
